import { normalizeUkDigits, phonesEquivalent } from './phone';
import { findSuppliersByPhone, type SupplierMatch } from './identity';

export function supplierAlreadyHasPhone(phones: Array<string | null | undefined>, incoming?: string | null): boolean {
  const needle = normalizeUkDigits(incoming);
  if (!needle) return false;
  return phones.some((value) => phonesEquivalent(value, needle));
}

export function otherSupplierWithPhone(
  suppliers: SupplierMatch[] | undefined,
  supplierId: string,
  phone?: string | null,
): SupplierMatch | null {
  return findSuppliersByPhone(suppliers, phone).find((supplier) => supplier.id !== supplierId) || null;
}
